import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as commonActions from './../../actions/commonActions';
/**
 * Component that to track outside Profile div click
 */
@connect(state => ({
  widgetKeyValue:state.dashboardRoot.commonReducer.widgetKeyValue
}), {
  ...commonActions,
})

export default class CalOutsideAlerter extends Component {
  constructor(props) {
    super(props);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  static propTypes = {
    onClickCalender:PropTypes.func,
    widgetKeyValue: PropTypes.string
  }
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    try{
      this.wrapperRef = node;
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setWrapperRef', component:"CalOutsideAlerter"});
    }
  }

  /**
   * UPDATE PROPS
   */
  handleClickOutside(event) {
    try{
      if(this.props.keyValue === this.props.widgetKeyValue){
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            //this.wrapperRef.style.display='none';
            this.props.onClickCalender(false,this.props.keyValue);
        }
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleClickOutside', component:"CalOutsideAlerter"});
    }
  }
  render() {
    return <div ref={this.setWrapperRef}>{this.props.children}</div>;
  }
}

CalOutsideAlerter.propTypes = {
  children: PropTypes.element.isRequired,
};
